import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=0742390f&scoped=true&"
import script from "./ScrollButton.vue?vue&type=script&lang=js&"
export * from "./ScrollButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollButton.vue?vue&type=style&index=0&id=0742390f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0742390f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0742390f')) {
      api.createRecord('0742390f', component.options)
    } else {
      api.reload('0742390f', component.options)
    }
    module.hot.accept("./ScrollButton.vue?vue&type=template&id=0742390f&scoped=true&", function () {
      api.rerender('0742390f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollButton.vue"
export default component.exports